import { AppRoutes } from "./AppRoutes"
import { useFeatureFlags } from "./hooks/posthog/useFeatureFlags"
import { useAnalytics } from "./hooks/useAnalytics"
import { useAuthentication } from "./hooks/useAuthentication"
import { useIntercomSetup } from "./hooks/useIntercomSetup"
import { useUserLoader } from "./hooks/useUserLoader"

export default function App() {
  const featureFlag = useFeatureFlags()

  const jwt = useAuthentication()
  const { isUserLoaded, displayNewBelt, setDisplayNewBelt } = useUserLoader(jwt, featureFlag)
  useAnalytics()
  useIntercomSetup(isUserLoaded)

  return (
    <AppRoutes
      isUserLoaded={isUserLoaded}
      featureFlag={featureFlag}
      displayNewBeltModal={displayNewBelt}
      setDisplayNewBeltModal={setDisplayNewBelt}
    />
  )
}
